export enum AccountType {
    Checking = 'CHECKING',
    Savings = 'SAVINGS'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/echeck-accounttypes.enum.ts